import { render } from "./HeroiconsOutlineMicrophone.vue?vue&type=template&id=f2d61f82"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMicrophone.vue"]])

export default __exports__